import * as types from '../actions/actionTypes';
import serverApi from '../serverApi';
import { asyncActionCreator } from './asyncActionCreatorFactory';
import { squashIdIntoValue } from './utils';

export function fetchSqlServerInstances() {
    return asyncActionCreator(types.SQL_SERVER_INSTANCES_UPDATED, serverApi.fetchSqlServerInstances({ take: 500 }),
     json => json.items.map(squashIdIntoValue));
};

export function addSqlServerInstance(sqlServerInstance) {
    return asyncActionCreator(types.SQL_SERVER_INSTANCE_ADDITION_UPDATED, serverApi.addSqlServerInstance(sqlServerInstance),
     json => ({ ...sqlServerInstance, id: json }));
};

export function fetchInstanceDetails(sqlServerInstanceId) {
    return asyncActionCreator(types.DATABASES_ON_INSTANCE_UPDATED, serverApi.fetchInstanceDetails(sqlServerInstanceId),
     json => ({ instanceId: sqlServerInstanceId, databases: json.items }));
};

export function requestSqlServerInstanceValidation(sqlServerInstance) {
    return asyncActionCreator(types.SQL_SERVER_INSTANCE_STATUS_REQUESTED, 
        serverApi.requestSqlServerInstanceValidation(sqlServerInstance), json => json);
};


// WEBPACK FOOTER //
// ./src/js/actions/sqlServerInstanceActionCreators.js